import Subject from './Subject';

export default class ScrollInput {
	constructor() {
		this.toggleNextPage = false;
		this.direction = 0;
		this.threshold = 10;
		this.active = false;
		this.pageId = 0;
		this.maxPageId = 10;
		this.isScrolling = false;

		this.observable = new Subject(this.pageId);
		this.focusTo = new Subject(this.pageId);
	}
}
